import React from 'react'

function Notfound() {
  return (
    <div style={{textAlign:"center"}}>
      <h1> Selected Page is  not found</h1>
    </div>
  )
}

export default Notfound
